<template>
  <div>
    <a-drawer
      :zIndex="8990"
      :placement="right"
      width="500"
      :visible="visible"
      :afterVisibleChange="callTours"
      title="Tablet Information"
      @close="$emit('close')"
    >
      <div class="h-full max-w-full flex flex-col">
        <tablets-card-item :tabletItem="tablet" :actions="false" />
        <base-loader v-if="pendingTourRequest" :fetching="pendingTourRequest" class="mt-28" />
        <div v-if="!pendingTourRequest">
          <ul class="flex flex-col shadow mt-10 relative border">
            <!-- HEADER -->
            <div class="px-6 flex space-x-4 bg-secondary leading-10 border-b sticky top-0 z-100">
              <span class="mr-0.5">Mix</span>
              <span class="pl-1.5 border-l">Tour Names</span>
            </div>
            <!-- LIST -->
            <div class="p-1">
              <li v-for="tour in tours" :key="tour.uuid" class="p-1.5">
                <div
                  :class="['flex space-x-5 px-6 py-2 border w-full rounded ', isParent(tour.uuid)]"
                  @click="toggleItem(tour)"
                >
                  <div class="self-center">
                    <input
                      type="checkbox"
                      v-if="tour.state === 'Assigned'"
                      :value="tour.uuid"
                      v-model="selectedTours"
                    />
                  </div>
                  <div class="flex flex-grow flex-col pl-2 space-y-1.5">
                    <span class="text-sm">{{ tour.name }}</span>
                    <span
                      :class="[
                        stateColor(tour.state),
                        ' self-start p-0.5 text-xs font-semibold rounded text-white',
                      ]"
                      >{{ tour.state }}</span
                    >
                  </div>

                  <base-button-icon
                    @click="unAssignTour(tour)"
                    size="xs"
                    icon="close"
                    v-if="tour.state !== 'In Progress' && tour.state !== 'Completed'"
                    tooltip="Unassign from tablet"
                    class="self-center border-white ml-auto text-black"
                  >
                  </base-button-icon>
                </div>
              </li>
            </div>
          </ul>
          <!-- ACTIONS -->
          <div class="flex flex-col space-y-3 pt-4">
            <div class="flex justify-between">
              <base-button
                :action="clear"
                :disabled="!selectedTours.length > 0 || loading"
                context="secondary"
                size="sm"
                @click="selectedTours = []"
              >
                Clear
              </base-button>
              <base-button
                @click="submit()"
                :loading="loading"
                :action="mix"
                :disabled="!mixChange"
                size="sm"
                class="p-1"
              >
                Save
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import Drawer from 'ant-design-vue/lib/drawer'
import 'ant-design-vue/lib/drawer/style/index.css'
import TabletsCardItem from '../tablets/TabletsCardItem.vue'
import {BaseIcon, BaseButton, BaseButtonIcon, BaseLoader} from '@/components/base'
import _reject from 'lodash-es/reject'
export default {
  name: 'TourMix',
  props: {
    tablet: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {
    'a-drawer': Drawer,
    TabletsCardItem,
    BaseIcon,
    BaseLoader,
    BaseButton,
    BaseButtonIcon,
  },
  created() {
    this.initComponent()
  },
  data() {
    return {
      tours: [],
      showTours: false,
      pendingTourRequest: false,
      selectedTours: [],
      unassigned: false,
      originalParent: '',
      originalMix: [],
      loading: false,
      // mixChange: false,
    }
  },
  computed: {
    mixChange() {
      return JSON.stringify(this.originalMix) !== JSON.stringify(this.selectedTours)
    },
  },
  methods: {
    callTours() {},
    getTours() {
      let uuid = this.tablet.uuid
      return this.$store.dispatch('tablets/getAssignedTours', uuid)
    },
    async initComponent() {
      if (this.pendingTourRequest) {
        return
      }
      try {
        this.pendingTourRequest = true
        const response = await this.getTours()
        this.tours = response.results
        if (this.tours.find(tour => tour.uuid === tour.parent)) {
          this.selectedTours[0] = this.tours.find(tour => tour.uuid === tour.parent).uuid
          let children
          this.originalParent = this.selectedTours[0]
          children = this.tours
            .filter(tour => tour.uuid !== this.originalParent && tour.parent)
            .map(tour => tour.uuid)

          this.selectedTours.push(...children)
          this.originalMix = this.selectedTours.slice()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.pendingTourRequest = false
      }
    },
    stateColor(state) {
      switch (state) {
        case 'Open':
          return 'bg-secondary-dark'
        case 'In Progress':
          return 'bg-yellow-500'
        case 'Assigned':
          return 'bg-blue-400'
        case 'Completed':
          return 'bg-green-400'
      }
    },
    toggleItem(tour) {
      if (this.unassigned) {
        this.unassigned = false
        return
      }
      if (tour.state !== 'Assigned') {
        return
      }
      if (!this.selectedTours.includes(tour.uuid)) {
        this.selectedTours.push(tour.uuid)
      } else {
        this.selectedTours = this.selectedTours.filter(item => item !== tour.uuid)
      }
    },
    isParent(id) {
      return !this.selectedTours.includes(id)
        ? 'hover:bg-secondary-light'
        : this.selectedTours[0] === id
        ? 'bg-secondary-dark text-white hover:disabled'
        : 'bg-secondary'
    },
    async submit() {
      this.loading = true
      const [parent, ...children] = this.selectedTours
      try {
        let payload = {
          parent: '',
          children: [],
        }
        //if new parent, unlink previous tour mix
        if (this.originalParent && parent !== this.originalParent) {
          payload.parent = this.originalParent
          await this.$store.dispatch('tours/mixTours', payload)
        }
        //create/update tour mix
        if (parent) {
          payload.parent = parent
          payload.children = children
          await this.$store.dispatch('tours/mixTours', payload)
          this.originalParent = parent
        }
        this.originalMix = this.selectedTours.slice()
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
    async unAssignTour(tour) {
      this.unassigned = true
      if (
        confirm(
          this.$t(`mygwf.components.Confirmation.tour_confirm_unassign`, {
            name: tour.name,
            assigned_to: tour.assigned_to,
          })
        )
      ) {
        try {
          this.loading = true
          await this.$store.dispatch('tours/unAssignTablet', tour)

          await this.$store.dispatch('app/notification', {
            type: 'success',
            group: 'app',
            text: `unassigned`,
          })
        } catch (error) {
          console.log(error)
        } finally {
          if (this.selectedTours[0] === tour.uuid) {
            this.selectedTours = []
            this.originalMix = []
          } else {
            this.selectedTours = this.selectedTours.filter(item => item !== tour.uuid)
            this.originalMix = this.selectedTours.slice()
          }
          this.tours = _reject(this.tours, ['uuid', tour.uuid])

          this.unassigned = false
          this.loading = false
        }
      }
    },
  },
}
</script>

<style></style>
